// Serbian

export default {
  component: {

    supportLink: 'support@recright.com',

    layout: {
      endTime: date => (date ? `otvorite do ${date}` : ''),
    },
    interview: {
      title: 'Odgovorite na video razgovor',
      submit: 'Pošaljite odgovore i završite razgovor',
      continueLater: 'Nastavite kasnije',
      startInterview: 'Započnite razgovor',
      duplicateError: 'Već ste učestvovali u ovom razgovoru. Dobili ste e-poruku od invitations@raceright.com koja sadrži link koji se može koristiti za nastavak razgovora.',
      confirmSubmitHeader: 'Niste odgovorili na sva pitanja za razgovor',
      confirmSubmitContent: 'Da li stvarno želite da završite razgovor?',
      confirmSubmitContentWarning: 'Posle ovoga, nećete moći da završite svoje odgovore.',
      submitInterviewHeader: 'Pošaljite svoje odgovore za intervju',
      submitInterviewContent: 'Da li ste sigurni da želite da pošaljete svoj intervju?',
      confirmSubmitButton: 'Pošalji odgovore i završi razgovor',
      preview: 'Možete pregledati video pitanja ovde.',
      requiredQuestionsNotAnswered: 'Molimo odgovorite na sva obavezna pitanja pre slanja.',

      withdrawLink: 'Više niste zainteresovani za ovo mesto? Povucite se iz procesa ovde.',
    },

    personalInterview: {
      title: 'Select time for an appointment',
      description: [
        'You have been invited to an appointment.',
        'Please select a time slot that suits you best.',
      ],
      position: 'Position:',
      location: 'Location:',
      time: 'Time:',
      timezoneNotice: [
        'Please keep in mind that the times are shown in your timezone.',
        'Your timezone appears to be:',
        'The appointment timezone is:',
      ],
      success: {
        title: 'Thank you',
        description: 'You have successfully scheduled a meeting',
        linkDescription: [
          'You can add the calendar invitation to your own calendar below.',
          'Or you can copy the link to your calendar app:',
        ],
        link: 'Add the calendar invitation to your calendar',
      },
    },

    interviewForm: {
      name: 'Ime',
      city: 'Rodno mesto',
      email: 'Imejl adresa',
      phone: 'Broj telefona',
      link: 'Link',
      legendBasicInfo: 'Osnovni podaci',
      placeholderName: 'Unesite vaše ime',
      placeholderEmail: 'Unesite vašu adresu e-pošte',
      placeholderPhone: 'Unesite vaš telefonski broj',
      placeholderCity: 'Unesite vaše mesto prebivališta',
      placeholderLink: 'Dodajte link, na primer vaš LinkedIn profil.',
      legendAttachments: 'Prilozi',
      legendAdditionalFields: 'Dodatne informacije',
      required: 'Stavke obeležene sa * zvezdicom su obavezne',
    },

    sequencedInterview: {
      networkTest: {
        audio: 'Audio',
        video: 'Video',
        yes: 'Da',
        no: 'Ne',
        supported: 'Podržan',
        quality: 'Kvalitet',
        header: 'Provera povezanosti s mrežom i uređajem',
        description: 'Sada ćemo pokrenuti testiranje da bismo proverili da li je vaš uređaj povezan s mrežom i da li je hardver koji treba koristiti tokom intervjua (kamera i telefon) ispravan. Kada se pojavi obaveštenje, treba da dozvolite da se kamera i mikrofon testiraju – kamera ne sme biti pokrivena. Testiranje traje oko 30 sekundi. Preporučujemo da kažete nešto tokom testiranja hardvera.',
        inProgress: 'Testiranje je u toku...',
        networkTestResults: 'Rezultati testa mreže',
        qualityTestResults: 'Rezultati testa kvaliteta',
        testPassedQuality: 'Položen test kvaliteta',
        testFailedQuality: 'Test kvaliteta nije uspešan',
        testPassedNetwork: 'Prošao test mreže',
        testFailedNetwork: 'Nije prošao test mreže',
        startTest: 'Započni testiranje',
        startInterview: 'Započni intervju',
        testAgain: 'Testiraj ponovo',
        confirmWarning: 'Kada video-intervju počne, automatski ćete preći na prvo pitanje u intervjuu. Nakon pregleda pitanja preći ćete na pripremu.',
        confirmTitle: 'Intervju će uskoro početi',
        confirmText: 'Imate malo vremena da se spremite za odgovor pre svakog pitanja. Nakon pripreme imate unapred određeno vreme da odgovorite na pitanje. Imajte u vidu da možete da prosledite odgovor kad budete spremni, a pre isteka unapred određenog vremena.',
        confirmText2: 'Nakon slanja odgovora prelazite na sledeće pitanje, sve dok se ne daju odgovori na sva pitanja.',
        confirmText3:
          'Imajte na umu to da ćete nakon snimanja odgovora na pitanje imati 30 sekundi da ponovo date odgovor ako je za to pitanje dozvoljeno ponovno unošenje odgovora. Ako ne pokrenete ponovno davanje odgovora u roku od 30 sekundi, trenutni odgovor se automatski šalje i bićete usmereni na naredno pitanje.',
        goodLuck: 'Samo duboko udahnite i sve će biti u redu. Srećno!',
        qualityRating: {
          excellent: 'Odlično',
          good: 'Dobro',
          fair: 'U redu',
          poor: 'Loše',
          bad: 'Veoma loše',
        },
      },
      questionAnswerView: {
        title: title => `Odgovori na intervju ${title}`,
        question: 'Pitanje',
        submitAndNext: 'Pošalji i idi dalje',
        submitSuccess: 'Video-snimak je uspešno poslat!',
        skipText: 'Započni snimanje',
        stop: 'Prekini',
        submitAndFinish: 'Prosledi i završi intervju',
        retake: 'Ponovni pokušaj',
        take: 'Pokušaj',
        takesLeft: 'Preostalo pokušaja',
        skipTextQuestion: 'Jeste li spremni? Nastavite dalje',
        retakeConfirmTitle: 'Da li zaista želite da ponovo date odgovor na ovo pitanje?',
        retakeConfirmSubmit: 'Da, pokreni ponovan unos odgovora',
        submitInfoForward: 'Automatsko slanje trenutnog odgovora i nastavak za',
        submitInfoForward2: 'sek.',
        nonAnswerableText: 'Na ovu poruku nije potrebno odgovoriti. Nakon ove poruke preći ćete direktno na sledeće pitanje.',
        nonAnswerableVideo: 'Ovaj video ne zahteva odgovor. Nakon ovog videa preći ćete direktno na sledeće pitanje.',
        answerTimeInfo: (answerMinutes, answerSeconds) =>
          `Imate ${answerMinutes} min i ${answerSeconds} s da odgovorite na pitanje.`,
      },
      publisher: {
        toNextQuestion: timer => `Prelazak na sledeće pitanje za ${timer}`,
        recordingStarts: timer => `Snimanje počinje za ${timer}`,
      },
      errors: {
        tooManyConnections: 'Ova veza je zatvorena jer je jedna veza već otvorena u drugoj kartici ili drugom prozoru.',
        unsupportedBrowser: 'Nažalost, vaš veb-pregledač ne dozvoljava ovu radnju. Molimo probajte s nekim drugim veb-pregledačem.',
        networkError: 'Nema internet veze.',
        reconnecting: 'Veza je prekinuta. Pokušajte da se ponovo povežete.',
        generalError: 'Nešto nije u redu. Osvežite stranicu i pokušajte ponovo.',
        allowMediaDevicesError: 'Ova radnja nije pronašla medijske uređaje (kamera ili mikrofon). Morate dozvoliti veb-pregledaču da koristi vašu kameru i mikrofon.',
        noAvailableDevicesError: 'Nismo pronašli kameru ili mikrofon.',
        initPublisherError: 'Operacija nije uspela jer je došlo do greške. Proverite da li ste dozvolili pregledaču da koristi kameru i mikrofon, kao i da ih ne koristi druga aplikacija, a zatim pokušajte ponovo.',
      },
      browserInfo: {
        browserSupportTitle: 'Podrška veb-pregledača',
        supportedBrowsers: 'Ovaj test i intervju podržavaju najnovije verzije pregledača Chrome, Firefox, Safari i Edge.',
        mobileSupported: 'Veb-pregledači koji su podržani na mobilnim uređajima',
        android: 'Android: Google Chrome (najnovija verzija), Firefox (najnovija verzija)',
        iOS: 'iOS: Safari (najnovija verzija)',
        latestVersion: 'Morate koristiti najnoviju verziju veb-pregledača kako bi sve teklo glatko.',
        freezeInstruction: 'Ako snimanje video-zapisa ne započne ili ako ekran koji se snima bude crn, osvežite stranicu.',
        unsupportedOnIos: 'Izgleda da koristite veb-pregledač koji iOS ne podržava. Morate koristiti Safari.',
        ieUnsupported: 'Izgleda da koristite Internet Explorer. Nažalost, Internet Explorer se ne može koristiti tokom ovog testiranja ili intervjua pa zato morate koristiti drugi pregledač.',
        qualityTestNotSupported: 'Nažalost, testiranje hardvera nije omogućeno za veb-pregledač koji koristite. Možete nastaviti intervju i bez testiranja audio i video kvaliteta ili pređite na drugi pregledač.',
      },
      reconnectSuccess: 'Ponovna veza je uspostavljena!',
      continue: 'Nastavi',
    },

    withdraw: {
      title: 'Više niste zainteresovani za ovu poziciju?',
      description: 'Povucite se iz procesa regrutacije.',
      buttonText: 'Povlačenje iz procesa regrutacije',
      thankYouTitle: 'Hvala vam!',
      thankYouText: 'Ovim ste obavestili regrutere da više niste zainteresovani za ovu poziciju.',
      confirm: 'Jeste li sigurni da se želite povući iz procesa regrutacije? Nakon povlačenja nećete moći da se javite na ovaj niti na bilo koji drugi razgovor u vezi s ovom pozicijom.',
    },
  },

  page: {
    embeddedProfileInterview: {
      submit: 'Predaj',
      continue: 'Nastavi',
      supportCenter: 'Recright Help Center',
      thankYou:
        'Hvala vam na vašem video odgovoru! Kontaktiraćemo vas u bliskoj budućnosti!',
    },

    supportLink: 'support@recright.com',

    finished: {
      title: 'Hvala vam što ste učestvovali u razgovoru!',
      reopenDescription: 'Ako ste slučajno zatvorili ovaj intervju – ne brinite! Kliknite na dugme ispod da biste ponovo otvorili intervju.',
      reopenButtonText: 'Ponovo otvori intervju',
      description1: 'Odlično, odgovorili ste na sva pitanja i poslata su primaocu.',
      descriptionsupport: mailto => `Ako ste slučajno zatvorili ovaj razgovor, kontaktirajte našu službu podrške ${mailto} i ponovo ćemo otvoriti vaš razgovor.`,
      descriptionfeedback: 'Vaše iskustvo nam je veoma važno! Kakvo je bilo vaše iskustvo ovog video razgovora? Kako biste poboljšali naše usluge? Ostavite povratne informacije ovde.',
      feedbackbutton: 'Ostavite nam povratne informacije!',
      regularUrl: 'https://www.surveymonkey.com/r/B3ZCSWT',
      timedUrl: 'https://www.surveymonkey.com/r/MZMLPPT',
    },
    messages: {
      title: 'Lična poruka',
    },

    closed: {
      title: 'Razgovor je završen ili je istekao',
      description: 'Vide razgovor na koji ste bili pozvani je već gotov ili ste predali sve odgovore.',
      publicTitle: 'Interview has ended',
      publicDescription: 'The video interview has already ended.',
    },
    saved: {
      title: 'Vaš video razgovor je sada sačuvan!',
      description: 'Kada želite da nastavite video razgovor, upotrebite link koji ste već primili na vašu adresu e-pošte. Već snimljeni video odgovori će biti tu kada se vratite! Srećno u lovu na posao!',
      remember: 'Zapamtite da treba da pošaljete odgovore regruteru kada završite sa odgovaranjem na razgovor.',
      deleteHistory: 'Ako odgovarate na razgovor na javnom računaru, očistite istoriju pregledanja. Tako će vaš razgovor biti bezbedan.',
    },
    unpublished: {
      title: 'Intervju još nije otvoren',
      publishTime: publishTime => `Intervju će biti otvoren u sledeće vreme: ${publishTime}`,
    },
  },
}
